import React, { useState } from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const Carousel = ({
  children,
  navColor,
  dotsColor,
  dotsActiveColor,
  settings,
  withNav,
  fullMobile,
  marginTop,
  ...props
}) => {
  const [swiper, setSwiper] = useState(null)

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext()
    }
  }

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev()
    }
  }

  return (
    <S.CarouselWrapper
      dotsColor={dotsColor}
      dotsActiveColor={dotsActiveColor}
      {...props}
      fullMobile={fullMobile}
      marginTop={marginTop}
    >
      <S.Carousel {...settings} getSwiper={setSwiper}>
        {children}
      </S.Carousel>
      {withNav && (
        <S.CarouselPrev onClick={goPrev}>
          <S.CarouselIcon color={navColor} name="arrow-left-1" />
          <span>Anterior</span>
        </S.CarouselPrev>
      )}
      {withNav && (
        <S.CarouselNext onClick={goNext}>
          <S.CarouselIcon color={navColor} name="arrow-right-1" />
          <span>Próximo</span>
        </S.CarouselNext>
      )}
    </S.CarouselWrapper>
  )
}

Carousel.defaultProps = {
  navColor: 'neutral500',
  dotsColor: 'white',
  dotsActiveColor: 'blue500'
}

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
  navColor: PropTypes.string,
  withNav: PropTypes.bool,
  fullMobile: PropTypes.bool,
  dotsColor: PropTypes.string,
  dotsActiveColor: PropTypes.string,
  marginTop: PropTypes.number
}

export default Carousel
